import { ReactElement, ReactNode, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import ElementControllerContext from './element-controller-context';

const ElementControllerProvider = ({ children }: { readonly children: ReactNode }): ReactElement => {
  const location = useLocation();

  const [enableSidebar, setEnableSidebar] = useState(true);
  const sideMenuRef = useRef<HTMLTdsSideMenuElement>(null);

  const toggleMobileNav = useCallback((): void => {
    if (sideMenuRef.current) sideMenuRef.current.open = !sideMenuRef.current.open;
  }, []);

  useEffect(() => {
    if (sideMenuRef.current) sideMenuRef.current.open = false;
  }, [location]);

  const value = useMemo(
    () => ({ sideMenuRef, enableSidebar, setEnableSidebar, toggleMobileNav }),
    [enableSidebar, toggleMobileNav],
  );

  return <ElementControllerContext value={value}>{children}</ElementControllerContext>;
};

export default ElementControllerProvider;
